<template>
    <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
        <v-container>
            <v-row class="mb-5" >

                <v-col cols="12" >
                    <v-row>
                        <h1 :style="`color:${mainColor}`">Bots</h1>
                    </v-row>
                </v-col>
                <v-col class="text-center" cols="12" v-if="onLoading">
                    <loading-circular/>
                </v-col>
            </v-row>
            <v-row  >
                <v-col cols="10" offset="1" v-for="(company, index) in companies" :key="index" class="mb-4">
                    <v-card :style="{color:style.fontColor}" hover>
                        <v-container fluid style="cursor: default">
                            <v-row>
                                <v-col cols="3">
                                    <v-card-title primary-title>
                                        <div>
                                            <h4 class="mb-0">{{company.companyName}}</h4>
                                        </div>
                                    </v-card-title>
                                </v-col>
                                <v-col cols="7">
                                    <v-card-title primary-title>
                                        <div>
                                            <h4 class="mb-0">{{company.description}}</h4>
                                            <div class="body-2">Creado en {{new Date(company.creationDate.seconds * 1e3).toString()  | dateFilter}}</div>
                                        </div>
                                    </v-card-title>
                                </v-col>
                                <v-col cols="2">
                                    <v-row justify="end" class="pb-2 pr-2">
                                        <v-tooltip
                                            bottom
                                            >
                                            <template v-slot:activator="{on}">
                                                <v-btn
                                                    @click="goToCategories(company.companyId, company.companyName)"
                                                    dark
                                                    fab
                                                    small
                                                    :color="mainColor"
                                                    outlined
                                                    v-on="on"
                                                >
                                                Ver
                                                </v-btn>
                                            </template>
                                            <span>Abrir bot</span>
                                        </v-tooltip>
                                    </v-row>
                                    <v-row justify="end" class="pr-2">
                                        <v-tooltip
                                            bottom
                                            >
                                            <template v-slot:activator="{on}">
                                                <v-btn
                                                    @click="goToDelete(company.companyId)"
                                                    dark
                                                    fab
                                                    small
                                                    icon
                                                    :color="mainColor"
                                                    outlined
                                                    v-on="on"
                                                ><v-icon>{{deleteIcon}}</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Borrar bot</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
/* eslint-disable no-console */
import { mdiDeleteOutline, mdiAndroidDebugBridge } from '@mdi/js'
import * as constants from '../../../constants.json'

export default {
  data () {
    return {
    //   companies: [],
      deleteIcon: mdiDeleteOutline,
      botIcon: mdiAndroidDebugBridge,
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      }
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    user () {
      return this.$store.getters.getUser
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    },

    companies () {
      return this.$store.getters.getLoadedCompanies
    }
  },

  watch: {
    /**
     * If no user exists we load the main view.
     */
    user (value) {
      if (value === null || value === undefined || value.role === 'editor' || value.role === 'administrator') {
        this.$router.push('/')
      }
    }
  },

  async created () {
    this.$store.dispatch('actionSetToolbar', false)
    // Load companies from database
    try {
      this.$store.commit('mutationSetCompanyData', { companyName: '' })
      await this.$store.dispatch('actionLoadCompanies')
      //   this.companies = this.$store.getters.getLoadedCompanies

      console.log('this.companies', this.companies)
    } catch (error) {
      throw error
    }
  },

  methods: {
    async goToCategories (companyId, companyName) {
      console.log('companyId ', companyId)

      this.$store.dispatch('actionSetToolbar', true)

      this.$store.commit('mutationSetCompanyData', { companyName })

      localStorage.companyId = companyId
      this.$router.push({ name: 'Categories' })
    },

    async goToDelete (companyId) {
      console.log('companyId ', companyId)
      confirm('¿Deseas eliminar este item?') && await this.$store.dispatch('actionDeleteCompany', { companyId: companyId })
    }
  }
}
</script>
